import axios from 'axios';
import { axiosEc, axiosMall } from '@/config/axios.config';
import { createBridgeApiConfig } from '@/runtime/config/bridge-api.config';
import { createBridgeEnvConfig } from '@/runtime/config/bridge-env.config';

/**
 * 安裝 config runtime，供 Razor 舊頁面共用
 */
export const installConfigRuntime = (): void => {
    const envConfig = createBridgeEnvConfig();
    const apiConfig = createBridgeApiConfig(envConfig);

    window.ENV_CONFIG = envConfig;
    window.API_HOME_PAGE = apiConfig.API_HOME_PAGE;
    window.API_ProductsClassification = apiConfig.API_ProductsClassification;
    window.API_EC = apiConfig.API_EC;
    window.API_MALL = apiConfig.API_MALL;

    try {
        // 提供舊頁面可直接使用 axios 全域物件
        window.axios = axios;
        window.axiosEc = axiosEc;
        window.axiosMall = axiosMall;
    } catch (error) {
        console.warn('[gh-components] config runtime 初始化失敗:', error);
    }

    window.__GH_CONFIG_RUNTIME_READY__ = true;
};
